import { render, staticRenderFns } from "./PointAffiliatedFacilityReservation.vue?vue&type=template&id=6b0063ca&scoped=true&"
import script from "./PointAffiliatedFacilityReservation.vue?vue&type=script&lang=js&"
export * from "./PointAffiliatedFacilityReservation.vue?vue&type=script&lang=js&"
import style0 from "./PointAffiliatedFacilityReservation.vue?vue&type=style&index=0&id=6b0063ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0063ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDialog,VForm,VIcon,VTextField})
